<template>
  <div v-if="isLoading" class="loader-container">
    <img src="./assets/images/icon-gif.gif" alt="ebtkar logo" />
  </div>
  <div v-else>
    <GoTop />
    <router-view />
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import GoTop from "./components/Layout/GoTop.vue";
import { useAuthStore } from "./store/authStore";
import { useI18n } from "vue-i18n";
import apiClient from "./Services/apiClient";
const isLoading = ref(true);

const authStore = useAuthStore();

authStore.initializeFromStorage();
const { locale } = useI18n ? useI18n() : { locale: ref("en") }; // fallback if not using vue-i18n

function updateHtmlLangAttribute() {
  const storedLanguage = localStorage.getItem("language");
  document
    .querySelector("html")
    .setAttribute("lang", storedLanguage || "en");
}

watch(
  () => locale.value,
  (newLanguage) => {
    document.querySelector("html").setAttribute("lang", newLanguage);
  }
);

onMounted(async () => {
  await new Promise(resolve => setTimeout(resolve, 10));
  updateHtmlLangAttribute();

  // Start authentication check
  authStore.startAuthCheck();

  try {
    // Always check authentication status at startup
    const response = await apiClient.get('Auth/user-info');

    // User is authenticated
    authStore.initializeStore(
      response.data.data.userData,
      response.data.data.lastRole,
      response.data.data.roles,
      true
    );

  } catch (error) {
    console.log('Authentication check failed:', error);

    // User is not authenticated
    authStore.logout();
  } finally {
    // Complete authentication check
    authStore.completeAuthCheck();
    isLoading.value = false;
  }
});

</script>

<style lang="scss">
img{
  width: 12rem
}
</style>
